'use client';

import Icon from '@/components/ui/AppIcon';

interface ValidationMessageProps {
  message: string;
  type: 'error' | 'warning';
}

const ValidationMessage = ({ message, type }: ValidationMessageProps) => {
  const styles = type === 'error' ?'bg-[#1A0A0A] border-[#C0392B]/40 text-[#C0392B]' :'bg-[#1A1408] border-[#C9A96E]/30 text-[#C9A96E]';

  const iconName = type === 'error' ? 'XCircleIcon' : 'ExclamationTriangleIcon';

  return (
    <div className={`border px-4 py-3 ${styles} animate-scale-in`} style={{ borderRadius: 0 }}>
      <div className="flex items-start space-x-3">
        <Icon name={iconName as any} size={18} className="flex-shrink-0 mt-0.5" />
        <p className="font-light text-sm tracking-wide">{message}</p>
      </div>
    </div>
  );
};

export default ValidationMessage;